import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';

export const inputClass =
  'w-full rounded-lg border border-line bg-surface px-3 py-2 text-sm text-ink placeholder:text-muted/70 focus-visible:border-accent';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  error?: string;
  hint?: ReactNode;
}

export const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { label, error, hint, className = '', ...rest },
  ref,
) {
  return (
    <label className="block text-sm">
      {label && <span className="mb-1 block font-medium text-ink/80">{label}</span>}
      <input
        ref={ref}
        className={`${inputClass} ${error ? 'border-danger' : ''} ${className}`}
        {...rest}
      />
      {error && <span className="mt-1 block text-xs text-danger">{error}</span>}
      {hint && !error && <span className="mt-1 block text-xs text-muted">{hint}</span>}
    </label>
  );
});
